import { Route, RouterModule } from '@angular/router';
import { samlSsoRoute } from '@ats/auth-components';
import { adminGuard } from './guards/admin.guard';
import { supplyChainSupportGuard } from './guards/supply-chain-support.guard';

const routes: Route[] = [
  samlSsoRoute,
  {
    path: 'redirect',
    loadChildren: () =>
      import('./containers/redirect/redirect.module').then((m) => m.RedirectContainerModule)
  },
  {
    path: 'import',
    canActivate: [adminGuard],
    loadChildren: () =>
      import('./containers/import/import.module').then((m) => m.ExcelImportContainerModule)
  },
  {
    path: 'equipment',
    canActivate: [adminGuard],
    loadChildren: () =>
      import('./containers/equipment/equipment.module').then((m) => m.EquipmentContainerModule)
  },
  {
    path: 'models',
    canActivate: [adminGuard],
    loadChildren: () =>
      import('./containers/models/models.module').then((m) => m.ModelsContainerModule)
  },
  {
    path: 'people',
    canActivate: [adminGuard],
    loadChildren: () =>
      import('./containers/people/user-configuration.module').then(
        (m) => m.UserConfigurationContainerModule
      )
  },
  {
    path: 'site-configuration',
    canActivate: [supplyChainSupportGuard],
    loadChildren: () =>
      import('./containers/site-configuration/site-configuration.module').then(
        (m) => m.SiteConfigurationContainerModule
      )
  },
  { path: '**', pathMatch: 'full', redirectTo: 'redirect' }
];

export const appRouting = RouterModule.forRoot(routes);
